<template lang="pug" src="./penalties.pug"></template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    data: () => ({
        requestProcessing: false
    }),
    computed: {
        ...mapGetters(['userBrandId']),
        ...mapState({
            items: state => state.finances.penalties.items,
            brands: state => state.data.brands,
            pagination: state => state.finances.penalties.pagination,
            filters: state => state.finances.penalties.filters
        }),
        headers() {
            return ['title', 'fixedPenalty', 'brandId', 'actions'].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Penalties.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        },
        brandId: {
            get() {
                return this.filters.brandId;
            },
            set(val) {
                return this.$store.commit('finances/SET_PENALTIES_BRAND_ID', val);
            }
        },
        title: {
            get() {
                return this.filters.title;
            },
            set(val) {
                return this.$store.commit('finances/SET_PENALTIES_TITLE', val);
            }
        }
    },
    created() {
        if (this.userBrandId) {
            this.brandId = this.userBrandId;
        }

        this.$store.dispatch('data/getBrands').then(() => {
            if (!this.brandId) {
                this.brandId = this.brands && this.brands[0] && this.brands[0].id;
            }

            this.loadItems();
        });
    },
    methods: {
        loadItems(page = 1) {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('finances/getPenalties', Object.assign({}, {
                ...this.filters,
                page
            })).then(() => {
                this.$nextTick(() => this.requestProcessing = false);
            });
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadItems(page);
            }
        }
    }
};
</script>
